// src/components/About.jsx
import React from 'react';

const About = () => {
    return (
        <section id="about" className="about section">
            <div className="container">
                <div className="about-grid">
                    <div className="about-content">
                        <div className="section-header">
                            <h2 className="section-title">About WadeBros</h2>
                            <p className="section-subtitle">We Bring The Shine To You</p>
                        </div>

                        <p className="about-text">
                            At Wade Bros, we believe car care shouldn’t cost you your time.
                            That’s why we deliver premium mobile auto detailing straight to your doorstep —
                            with zero hassle and 100% attention to detail. From deep-cleaned interiors to
                            head-turning exteriors, we make sure your vehicle always looks its best.
                            Professional. Reliable.
                        </p>

                        <div className="about-stats">
                            <div className="stat-item">
                                <span className="stat-number">100+</span>
                                <span className="stat-label">Satisfied Customers</span>
                            </div>
                            <div className="stat-item">
                                <span className="stat-number">2</span>
                                <span className="stat-label">Certified Detailers</span>
                            </div>
                            <div className="stat-item">
                                <span className="stat-number">5★</span>
                                <span className="stat-label">Average Rating</span>
                            </div>
                        </div>

                    </div>
                    <div className="about-image">
                        <img src="/images/interior-details.jpeg" alt="WadeBros team working on a car" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;